import React, { useState } from 'react';
import {
  Flex,
  HStack,
  Heading,
  IconButton,
  Button,
  Input,
  Box,
} from '@chakra-ui/react';
import { BsPencil, BsShare, BsCheck, BsX } from 'react-icons/bs';

export const ChatHeader = ({ title, onTitleUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState(title);

  const handleSave = () => {
    if (editedTitle.trim()) {
      onTitleUpdate(editedTitle);
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setEditedTitle(title);
    setIsEditing(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <Flex
      pb={2}
      borderBottomWidth="1px"
      alignItems="center"
      justifyContent="space-between"
    >
      <HStack gap={2} flex={1}>
        {isEditing ? (
          <Flex gap={2} flex={1} alignItems="center">
            <Input
              value={editedTitle}
              onChange={(e) => setEditedTitle(e.target.value)}
              onKeyDown={handleKeyPress}
              size="sm"
              autoFocus
              maxW="500px"
            />
            <IconButton
              aria-label="Save"
              icon={<BsCheck />}
              size="sm"
              colorScheme="green"
              onClick={handleSave}
            />
            <IconButton
              aria-label="Cancel"
              icon={<BsX />}
              size="sm"
              variant="ghost"
              onClick={handleCancel}
            />
          </Flex>
        ) : (
          <>
            <Heading as="h2" size="sm" color="gray.800" noOfLines={1}>
              {title.length > 60 ? title.substring(0, 60) + '...' : title || 'New Conversation'}
            </Heading>
            <IconButton
              aria-label="Edit"
              variant="ghost"
              size="sm"
              h={7}
              px={2}
              color="gray.400"
              _hover={{ color: 'gray.700', bg: 'gray.100' }}
              onClick={() => setIsEditing(true)}
            >
              <BsPencil />
            </IconButton>
          </>
        )}
      </HStack>
      {!isEditing && (
        <Button variant="outline" size="sm" h={8} color="gray.600" borderColor="gray.300" _hover={{ bg: 'gray.50', color: 'gray.800' }}>
          <Box as={BsShare} mr={1} />
          Share
        </Button>
      )}
    </Flex>
  );
};
